import React, { useState } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import IwMenu from "../../../app/IwMenu";
import { RemoveFromGroupModal } from "../../common/RemoveFromGroup.modal";
import AssignSeatModal from "../../common/AssignSeat.modal";
import { useNavigate } from "react-router-dom";

export const ActionCell = ({...props}) => {

  const {
    row,
    handleOpenAddRoleModal,
    setOpenMakeAdministratorModal,
    setSingleUserData
  } = {...props}

  const [openRemoveFromOrgModal, setOpenRemoveFromOrgModal] = useState(false);
  const [openAssignSeatModal, setOpenAssignSeatModal] = useState(false);

  const navigate = useNavigate();

  return (
    <>
      <AssignSeatModal 
        tableRow={row?.original}
        open={openAssignSeatModal}
        handleClose={() => {
          setOpenAssignSeatModal(false);
        }}
      />
      <RemoveFromGroupModal
        open={openRemoveFromOrgModal}
        handleClose={() => {
          setOpenRemoveFromOrgModal(false);
        }}
        cohortTypeLabel="Organisation"
        roleID={row?.original?.roleID || null}
      />

      <IwMenu
        label={<MoreVertIcon fontSize="medium" />}
        tooltipProps={{ title: "Options" }}
        items={[
          {
            id: "add-role",
            label: "Add Roles",
            onClick: () => {
              handleOpenAddRoleModal();
            },
          },
          { id: "userSummary", 
            label: "View User Details", 
            onClick: () => {
              navigate(`/admin/${row?.original?.userID}`, {
                state: { userData: (({ roles, ...rest }) => rest)(row?.original || {})},
              })
            } },
          {
            id: "removeFromOrg",
            label: "Remove from Org",
            onClick: () => {
              setOpenRemoveFromOrgModal(true);
            },
          },
          {
            id: "administrator",
            label: "Make Administrator",
            onClick: () => {
              setSingleUserData(props.row.original)
              setOpenMakeAdministratorModal(true)
            },
          },
          {
            id: "assignSeat",
            label: "Assign Seat",
            onClick: () => {
              setOpenAssignSeatModal(true);
            },
          },
        ]}
      />
    </>
  );
};
 
